import { Subset } from '@payaca/utilities/types';
import { EntityType } from './entity-type';
import { TimestampedEntity } from './timestampedEntityTypes';

/**
 * The maximum size a file upload can be if uploaded via this application,
 * not directly to GCS from the client.
 */
export const UPLOAD_MAX_FILESIZE_LIMIT_VIA_APP = 30 * 1024 * 1024; // 30MB

export interface Upload extends TimestampedEntity {
  id: number;
  publicId: string;
  accountId?: number;
  url: string;
  thumbnailUrl?: string;
  fileName: string;
  fileExtension: string;
  mimeType: string;
  fileSize: number; // bytes
  isSystemManaged: boolean;
  metadata?: UploadMetadata;
}

export type UploadMetadata = {
  source:
    | {
        type: 'projectIntegration';
        service: 'EASY_PV' | 'HEATPUNK' | 'OPEN_SOLAR';
        projectIntegrationId: number;
        fileId?: string;
      }
    | {
        type: 'productSpecScrape';
        url: string;
      };
};

export interface UploadAttachableEntity {
  uploadIds: number[];
}

export type UploadAttachableEntityType = Subset<
  EntityType,
  | 'account'
  | 'automationAction'
  | 'changeProposal'
  | 'cityPlumbingProduct'
  | 'deal'
  | 'documentForm'
  | 'invoice'
  | 'material'
  | 'purchaseOrder'
  | 'scheduledEvent'
  | 'timelog'
  | 'user'
  | 'job'
  | 'servicePlan'
>;

export type ImageEditConfig = {
  crop: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  resize: { width: number; height: number };
};
